// extracted by mini-css-extract-plugin
export default {"textarea":"a-notes-dialog-module__textarea"};